/* angular:styles/component:css;b76ddf93fd14585576a3af9578d6b4df36a6d174b5ea2ff9171f4e65fc188328;/Users/stevennaimark/devtoil/Ziptility/Bivvy/src/app/tasks/components/task-list-table.component.ts */
.icon {
  padding: 0.5rem 0.75rem;
  border-radius: 0.375rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  font-weight: 600;
}
/*# sourceMappingURL=task-list-table.component.css.map */
